import { render, staticRenderFns } from "./TopStep.vue?vue&type=template&id=07c4f271&scoped=true&"
import script from "./TopStep.vue?vue&type=script&lang=js&"
export * from "./TopStep.vue?vue&type=script&lang=js&"
import style0 from "./TopStep.vue?vue&type=style&index=0&id=07c4f271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c4f271",
  null
  
)

export default component.exports